// Stage 11 — Escrow & contingencies.
// v1: milestone tracker placeholder + the planned AI integration for parsing
// the buyer's inspection PDF. Future: real escrow vendor handoff (First American
// Title) + AI inspection-report parsing via vision model.

const MILESTONES = [
  { id: "open",      label: "Escrow opened",                   eta: "Day 0",       blurb: "Contract sent to First American Title; file opened same-day." },
  { id: "title",     label: "Preliminary title report",        eta: "Day 1-3",     blurb: "Title pulls liens, easements, HOA, and chain of title." },
  { id: "inspection",label: "Buyer's inspection",              eta: "Day 5-12",    blurb: "Buyer's inspector visits; report drops within 48h. We parse it with AI." },
  { id: "appraisal", label: "Appraisal",                       eta: "Day 7-14",    blurb: "Lender orders. Low appraisals are the #2 deal-killer — we handle the rebuttal." },
  { id: "credits",   label: "Inspection / repair credits",     eta: "Day 12-17",   blurb: "AI translates buyer's repair-request into seller-friendly counter options." },
  { id: "contingencies",label: "Contingencies removed",        eta: "Day 17-21",   blurb: "Inspection, appraisal, loan contingencies — each removed in writing." },
  { id: "walkthrough",label: "Final walkthrough",              eta: "Day 28-29",   blurb: "Buyer walks the property one last time." },
];

export default function EscrowStage({ state, journey, update }) {
  return (
    <>
      <div className="s-ai-pill" style={{ marginBottom: 14 }}>
        ★ AI · Coming soon: parse buyer's inspection PDF → translate repair requests into seller-friendly counter options
      </div>

      <p style={{ color: "#5b7365", fontSize: 14, lineHeight: 1.7, margin: "0 0 14px" }}>
        Once an offer is accepted, escrow opens with our partner title company. Here's the full 30-day timeline you'll move through.
      </p>

      {MILESTONES.map((m, i) => (
        <div key={m.id} style={{ display: "flex", gap: 14, padding: "12px 0", borderBottom: i < MILESTONES.length - 1 ? "1px solid #f0f4f2" : "none" }}>
          <div style={{ flexShrink: 0, width: 80, fontFamily: "'DM Mono',monospace", fontSize: 11, color: "#9aa9a0", letterSpacing: "0.06em", textTransform: "uppercase", lineHeight: 1.4, paddingTop: 2 }}>
            {m.eta}
          </div>
          <div>
            <div style={{ fontWeight: 700, color: "#152d21", fontSize: 14, marginBottom: 3 }}>{m.label}</div>
            <div style={{ color: "#5b7365", fontSize: 13, lineHeight: 1.55 }}>{m.blurb}</div>
          </div>
        </div>
      ))}

      <p style={{ fontSize: 11, color: "#9aa9a0", fontFamily: "'DM Mono',monospace", marginTop: 14, letterSpacing: "0.04em" }}>
        STATUS · {state.status === "done" ? "complete" : "tracker live once an offer is accepted"}
      </p>
    </>
  );
}
